import { FunctionComponent } from "react";

import "./BouncingDots.scss";

export const BouncingDots: FunctionComponent = () => {
  return (
    <div className="bouncing-dots">
      <div className="dot" />
      <div className="dot" />
      <div className="dot" />
    </div>
  );
};
